import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const bobs27LocalGameRoutes: Route[] = [
    {
        path: 'local-games/bobs-27',
        loadComponent: () =>
            import('./pages/bobs-27-new-game/bobs-27-new-game.component').then((c) => c.Bobs27NewGameComponent),
    },
    {
        path: 'game/bobs-27',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/bobs-27-local-game-app/bobs-27-local-game-app.component').then(
                (m) => m.Bobs27LocalGameAppComponent
            ),
    },
];

export const bobs27VenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/bobs-27',
        loadComponent: () =>
            import('./pages/bobs-27-new-game/bobs-27-new-game.component').then((c) => c.Bobs27NewGameComponent),
    },
    {
        path: 'game/bobs-27',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/bobs-27-local-game-venue/bobs-27-local-game-venue.component').then(
                (m) => m.Bobs27LocalGameVenueComponent
            ),
    },
];
